import { useConvexAuth } from "convex/react";
import { useQuery } from "convex/react";
import { useAuth as useWorkOSAuth } from "@workos-inc/authkit-nextjs/components";
import { api } from "@/convex/_generated/api";

export function useAuth() {
  const { isLoading: convexLoading, isAuthenticated } = useConvexAuth();
  const { loading: workosLoading } = useWorkOSAuth();
  const user = useQuery(api.users.getCurrentUser);

  return {
    isLoading: convexLoading || workosLoading,
    isAuthenticated,
    user,
  };
}
